import { IconName, IconNamesEnum } from 'ngx-bootstrap-icons';

export class SegmentedNavigationItemModel {
  id: string;
  name: string;
  itemsCount?: number;
  isActive = false;
  icon: IconNamesEnum | IconName | undefined;
  onlyDesktop: boolean;

  constructor(
    id: string,
    name: string,
    itemsCount?: number,
    isActive = false,
    icon: IconNamesEnum | IconName | undefined = undefined,
    onlyDesktop = false,
  ) {
    this.id = id;
    this.name = name;
    this.itemsCount = itemsCount;
    this.isActive = isActive;
    this.icon = icon;
    this.onlyDesktop = onlyDesktop;
  }
}
